<div *ngIf="router.url !== '/sign_in' && router.url !== '/pw-reset' && router.url !== '/not-found-page'">
  <app-navi></app-navi>
  <app-header [componentRef]=componentRef></app-header>
</div>
<div class="main">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
<app-search *ngIf="search_flg" [componentRef]=componentRef></app-search>